"use strict";

var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _apply = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/apply"));
var _isNan = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/number/is-nan"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/typeof"));
var _isObject2 = _interopRequireDefault(require("lodash/isObject"));
var _defaults2 = _interopRequireDefault(require("lodash/defaults"));
var _ampersandState = _interopRequireDefault(require("ampersand-state"));
var _constants = require("../constants");
function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * The model returned from the {@link FeatureModel#parse} method.
 *
 * @typedef {Object} ParsedFeatureModel
 * @property {boolean|number|string} ParsedFeatureModel.value - The parsed val.
 * @property {string} ParsedFeatureModel.type - The type of the parsed val.
 */

/**
 * Feature model.
 *
 * @description
 * This model contains details on a single feature and is received from the
 * **WDM** service upon registration.
 */
var FeatureModel = _ampersandState.default.extend({
  idAttribute: 'key',
  // needed by Ampersand to determine unique item

  // Ampersand property members.

  props: {
    /**
     * Contains the unique identifier for this feature to be addressed by.
     *
     * @type {string}
     */
    key: 'string',
    /**
     * This property contains the date in which this feature was last modified.
     *
     * @type {date}
     */
    lastModified: 'date',
    /**
     * This property defines whether or not the feature is mutable.
     *
     * @type {boolean}
     */
    mutable: 'boolean',
    /**
     * This property contains the data type the string value should be
     * interpreted as.
     *
     * @type {FEATURE_TYPES}
     */
    type: 'string',
    /**
     * This property contains the string value of this feature.
     *
     * @type {string}
     */
    val: 'string',
    /**
     * This property contains the interpreted value of this feature.
     *
     * @type {any}
     */
    value: 'any'
  },
  /**
   * Class object constructor. This method safely initializes the class object
   * prior to it fully loading to allow data to be accessed and modified
   * immediately after construction instead of initialization.
   *
   * @override
   * @param {Object} attrs - An object to map against the feature's properties.
   * @param {Object} [options={}] - Ampersand options for `parse` and `parent`.
   */
  constructor: function constructor(attrs) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _defaults2.default)(options, {
      parse: true
    });
    return (0, _apply.default)(_ampersandState.default.prototype.constructor, this, [attrs, options]);
  },
  // Ampsersand method members.
  /**
   * Parse {@link FeatureModel} properties recieved as strings from **WDM**
   * and cast them as their appropriate types.
   *
   * @private
   * @memberof FeatureModel
   * @param {Object} model - The model to parse.
   * @property {string} model.val - The value to be parsed.
   * @returns {ParsedFeatureModel} - The parsed model.
   */
  parse: function parse(model) {
    // Validate that a model was provided and that it is an object.
    if (!model || (0, _typeof2.default)(model) !== 'object') {
      // Return an empty object to satisfy the requirements of `Ampersand`.
      return {};
    }
    var parsedModel = _objectSpread({}, model);
    var val = parsedModel.val;

    // Validate that the value is a number.
    if (!(0, _isNan.default)(Number(val))) {
      parsedModel.type = _constants.FEATURE_TYPES.NUMBER;
      parsedModel.value = Number(val);
    }
    // Validate if the value should be a true boolean.
    else if (typeof val === 'string' && val.toLowerCase() === 'true') {
      parsedModel.type = _constants.FEATURE_TYPES.BOOLEAN;
      parsedModel.value = true;
    }
    // Validate if the value should be a false boolean.
    else if (typeof val === 'string' && val.toLowerCase() === 'false') {
      parsedModel.type = _constants.FEATURE_TYPES.BOOLEAN;
      parsedModel.value = false;
    }
    // In all other cases, the value is string, even if it is undefined.
    else {
      parsedModel.type = _constants.FEATURE_TYPES.STRING;
      parsedModel.value = val;
    }
    return parsedModel;
  },
  /**
   * Serialize the feature using the parent ampersand method with its date as an
   * ISO string. This converts the feature into a request-transportable object.
   *
   * @override
   * @param  {Record<string,boolean>} [args] - List of properties to serialize.
   * @returns {Object} - The request-ready transport object.
   */
  serialize: function serialize() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    // Call the overloaded class member.
    var attrs = (0, _apply.default)(_ampersandState.default.prototype.serialize, this, args);

    // Validate that the overloaded class member returned an object with the
    // `lastModified` key-value pair and instance it as an ISO string.
    if (attrs.lastModified) {
      attrs.lastModified = new Date(attrs.lastModified).toISOString();
    }
    return attrs;
  },
  /**
   * Set a property of this object to a specific value. This method utilizes
   * code that exists within the `ampersand-state` dependency to handle
   * scenarios in which `key = {"key": "value"}` or
   * `key = "key", value = "value"`. Since the snippet is pulled directly from
   * `ampersand-state`, there is no need to test both scenarios.
   *
   * @override
   * @param {object | string} key - The key value, or object to be set.
   * @param {any} value - The key value or object to set the keyed pair to.
   * @param {any} options - The object to set the keyed pair to.
   * @returns {any} - The changed property.
   */
  set: function set(key, value, options) {
    // Declare formatted output variables for properly setting the targetted
    // property for this method.
    var attrs;
    var optns;

    // Validate if the key is an instance of any object or not.
    if ((0, _isObject2.default)(key) || key === null) {
      attrs = key;
      optns = value;
    } else {
      attrs = {};
      attrs[key] = value;
      optns = options;
    }
    attrs = this.parse(attrs, optns);
    return (0, _apply.default)(_ampersandState.default.prototype.set, this, [attrs, optns]);
  }
});
var _default = FeatureModel;
exports.default = _default;
//# sourceMappingURL=feature-model.js.map
